"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _glyphs = _interopRequireDefault(require("../glyphs"));

var _icons = require("../../legacy/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var iconMachineNameMap = {
  account: _glyphs["default"].account,
  "arrow-dotted": _icons.ArrowDottedIcon,
  "arrow-left": _glyphs["default"]["arrow-left"],
  "arrow-right": _glyphs["default"]["arrow-right"],
  automotive: _glyphs["default"].car,
  baidu: _glyphs["default"].baidu,
  blog: _glyphs["default"]["blog-post"],
  bullet: _icons.BulletIcon,
  "bullet-filled": _icons.BulletFilledIcon,
  checkmark: _glyphs["default"].check,
  chevron: _glyphs["default"]["caret-right"],
  "chevron-left": _glyphs["default"]["caret-left"],
  chipset: _glyphs["default"].chipset,
  "circle-check": _glyphs["default"]["check-circle"],
  "circle-close": _glyphs["default"].cancel,
  "circle-down": _glyphs["default"]["arrow-circle-down"],
  "circle-empty": _icons.CircleEmptyIcon,
  "circle-exclamation": _glyphs["default"]["alert-error"],
  "circle-filled": _icons.CircleFilledIcon,
  "circle-minus": _icons.CircleMinusIcon,
  "circle-play": _glyphs["default"]["play-alt"],
  "circle-plus": _icons.CirclePlusIcon,
  "circle-right": _glyphs["default"]["arrow-circle-right"],
  "circle-up": _glyphs["default"]["arrow-circle-up"],
  close: _glyphs["default"].close,
  "close-2": _glyphs["default"].close,
  "company-20": _icons.Company20Icon,
  "control-close": _glyphs["default"].close,
  "control-index": _icons.ControlIndexIcon,
  "control-index-20": _glyphs["default"]["applications-apps"],
  "control-next": _icons.ControlNextIcon,
  "control-previous": _icons.ControlPreviousIcon,
  "control-top": _glyphs["default"]["control-top"],
  "delete": _glyphs["default"]["backspace-delete"],
  "dev-kit": _glyphs["default"].devkit,
  doc: _glyphs["default"].doc,
  download: _glyphs["default"].download,
  education: _icons.EducationIcon,
  email: _glyphs["default"].email,
  enlarge: _glyphs["default"]["enlarge-expand"],
  eye: _icons.EyeIcon,
  facebook: _glyphs["default"].facebook,
  "facebook-inverted": _glyphs["default"].facebook,
  filter: _icons.FilterIcon,
  "flickr-background": _icons.SocialFlickrBackgroundIcon,
  "footer-language": _icons.FooterLanguageIcon,
  "footer-line-zigzag": _icons.FooterLineZigzagIcon,
  "footer-site-map": _icons.FooterSiteMapIcon,
  "footer-sites": _icons.FooterSitesIcon,
  globe: _glyphs["default"]["globe-world-north-america"],
  google: _glyphs["default"].googleplus,
  "google-inverted": _glyphs["default"].googleplus,
  hamburger: _glyphs["default"].menu,
  "hamburger-20": _glyphs["default"].menu,
  healthcare: _glyphs["default"].healthcare,
  home: _glyphs["default"].home,
  "home-20": _glyphs["default"].home,
  image: _glyphs["default"]["photo-image"],
  info: _glyphs["default"].info,
  "info-20": _glyphs["default"].info,
  instagram: _glyphs["default"].instagram,
  "instagram-inverted": _glyphs["default"].instagram,
  "internet-of-everything": _icons.InternetOfEverythingIcon,
  "invention-20": _icons.Invention20Icon,
  link: _glyphs["default"].link,
  "link-out": _glyphs["default"]["link-out"],
  linkedin: _glyphs["default"].linkedin,
  "linkedin-inverted": _glyphs["default"].linkedin,
  list: _glyphs["default"].list,
  loading: _icons.LoadingIcon,
  "loading-dark": _icons.LoadingDarkIcon,
  "logo-q": _icons.LogoQIcon,
  "logo-qualcomm": _icons.LogoQualcommIcon,
  "logo-qualcomm-china": _icons.LogoQualcommChinaIcon,
  "med-cta": _icons.MedCtaIcon,
  "mobile-computing": _glyphs["default"]["phone-mobile-smart"],
  modem: _glyphs["default"].modem,
  more: _glyphs["default"]["more-circle"],
  "more-20": _glyphs["default"]["more-circle"],
  networking: _glyphs["default"].networking,
  "news-20": _glyphs["default"]["chat-bubble-news"],
  pdf: _glyphs["default"].pdf,
  pin: _glyphs["default"]["location-pin"],
  pinterest: _glyphs["default"]["pinterest-box"],
  "pinterest-inverted": _glyphs["default"].pinterest,
  platform: _glyphs["default"].platform,
  play: _glyphs["default"].play,
  podcast: _glyphs["default"]["voice-sound"],
  ppt: _glyphs["default"].ppt,
  "press-release": _icons.PressReleaseIcon,
  "product-charging": _icons.ProductChargingIcon,
  "product-chipsets": _glyphs["default"].chipset,
  "product-consumer": _icons.ProductConsumerIcon,
  "product-hardware": _glyphs["default"].hardware,
  "product-software": _glyphs["default"].software,
  "product-wireless": _icons.ProductWirelessIcon,
  qq: _glyphs["default"].qq,
  qzone: _glyphs["default"].qzone,
  "reference-design": _icons.ReferenceDesignIcon,
  renren: _icons.RenrenIcon,
  replay: _icons.ReplayIcon,
  "ring-alt": _icons.RingAltIcon,
  rss: _glyphs["default"].rss,
  sdk: _icons.SdkIcon,
  search: _glyphs["default"].search,
  "search-20": _glyphs["default"].search,
  select: _icons.SelectIcon,
  "share-icon": _icons.ShareIconIcon,
  "shopping-cart": _glyphs["default"]["shopping-cart"],
  "smart-cities": _glyphs["default"]["city-smart"],
  "smart-homes": _icons.SmartHomesIcon,
  soc: _icons.SocIcon,
  "solutions-20": _glyphs["default"].solutions,
  tablet: _glyphs["default"].tablet,
  tag: _icons.TagIcon,
  tumblr: _glyphs["default"]["tumblr-box"],
  twitter: _glyphs["default"]["twitter-box"],
  "twitter-b": _icons.TwitterBIcon,
  "twitter-inverted": _glyphs["default"].twitter,
  txt: _glyphs["default"].txt,
  "up-down": _glyphs["default"].select,
  video: _glyphs["default"].video,
  wearables: _icons.WearablesIcon,
  webinar: _glyphs["default"].webinar,
  wechat: _glyphs["default"]["wechat-box"],
  weibo: _glyphs["default"].weibo,
  wifi: _glyphs["default"].wifi,
  xls: _glyphs["default"].xls,
  youku: _icons.YoukuIcon,
  youtube: _glyphs["default"]["youtube-box"],
  "youtube-inverted": _glyphs["default"].youtube,
  zip: _glyphs["default"].zip
};
var _default = iconMachineNameMap;
exports["default"] = _default;